import React from 'react';
import { Tag } from 'antd';
import './styles.less';

const TagsList = ( { title = 'Tags', tags } ) => {
    return (
        <div className="tags-list">
            { ( tags && tags.length > 0 ) &&
                <>
                    <p><strong>{ title }</strong></p>            
                    
                    <div className="tags">
                        { tags.map( i => (
                            <Tag 
                                color="green" 
                                key={ i.name }
                            >
                                { i.name }
                            </Tag> )
                        ) }
                    </div>
                </>
            }
        </div>
    );
};

export default  TagsList;
